interface FormFieldToggle {
  id?: string;
  value: string;
  checked: boolean;
  callbackChange: (value: boolean) => void;
}

export default function FormFieldToggle({
  id,
  value,
  checked,
  callbackChange
}: FormFieldToggle) {
  function changeToggle(e: React.FormEvent<HTMLInputElement>) {
    callbackChange(e.currentTarget.checked);
  }

  return (
    <label id={id ? `${id}-input` : undefined} className="switch-toggle">
      <input
        type="checkbox"
        value={value}
        checked={checked}
        onChange={changeToggle}
      />
      <span className="slider round"></span>
    </label>
  );
}

// ex: Implementation
{
  /*
      <FormFieldToggle />
  */
}
